import moment from "moment";
import _ from 'lodash';
import { Tokens } from '@Utilities/enum'
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
const date_start = _.has(window, 'Subscription') ? window.Subscription.date_start : ''
// const date_end = _.has(window, 'Subscription') ? window.Subscription.date_end : ''
const default_date = _.has(window, 'Subscription') ? window.Subscription.default_date_range : ''

const defaultFilters = {
    dates: {
        date_from: default_date.date_start,
        date_to: default_date.date_end
    },
    permutations: [],
    metric_groups: []
}

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isLoadingMore: false,
        analyticsData: {},
        adminAnalyticsData: {},
        adminSavedParams: {
            date: moment(date_start).format("YYYY-MM"),
            page: 1
        },
        aggregationTableData: {},
        currentFilter: {},
        saveFilters: _.isEmpty(cookies.get(Tokens.Filters)) ? _.cloneDeep(defaultFilters) : cookies.get(Tokens.Filters),
        filters: {},
        filterLoader: false
    },
    getters: {
        isLoading: (state) => {
            return state.isLoading
        },
        isLoadingMore: (state) => {
            return state.isLoadingMore
        },
        analyticsData: (state) => {
            return state.analyticsData
        },
        adminAnalyticsData: (state) => {
            return state.adminAnalyticsData
        },
        adminSavedParams: (state) => {
            return state.adminSavedParams
        },
        aggregationTableData: (state) => {
            return state.aggregationTableData;
        },
        exportUrl: state => {
            return state.exportUrl;
        },
        saveFilters: state => {
            return state.saveFilters;
        },
        filters: state => {
            return state.filters
        },
        filterLoader: state => {
            return state.filterLoader
        }
    },
    actions: {
        async getAnalytics ({ commit, state, dispatch }, payload) {

            commit('setIsLoading', true)

            try {
                const { attribute, dimension, type, slug, sort, sub_class } = payload
                const { dates, permutations, metric_groups } = state.saveFilters;

                const params = {
                    date_from: moment(dates.date_from).format("YYYY-MM"),
                    date_to: moment(dates.date_to).format("YYYY-MM"),
                    sort,
                    sub_class
                };

                if (!_.isEmpty(sub_class)) {
                    params.sub_class = sub_class
                }

                if (!_.isEmpty(permutations)) {
                    params.permutations = { ids: _.map(permutations, 'id') }
                }

                if (!_.isEmpty(metric_groups)) {
                    params.metric_groups = { ids: _.map(metric_groups, 'id') }
                }
                const path = `/analytics/${dimension}/${attribute}/${type}/${slug}`;

                const response = await axios.get(path, { params })

                if (response && response.success) {

                    commit('setIsLoading', true)
                    if (!state.analyticsData) {
                        let table = response.data.graphs.filter((item) => {
                            return item.type === 'table'
                        })
                        table = table ? table[0] : null
                        if ( "options_filter" in table.data ) {
                            const month_filter = table.data.options_filter[0]
                            await dispatch('TableAnalytics/updateAnalyticsData',
                                { data: month_filter, attribute: null },
                                { root: true })
                            return
                        }
                    }

                    commit('setAnalyticsData', response.data)
                    commit('setIsLoading', false)

                    return
                }

                if (process.env.MIX_APP_ENV !== 'local.dhap') {
                    // window.location.href = "/error/500";
                }

            } catch (error) {
                console.warn(error)
            }
            commit('setIsLoading', false)
        },

        async getAdminAnalytics ({ commit, state }, payload) {
            const params = _.merge(state.adminSavedParams, payload)
            const loader = params.page > 1 ? 'setIsLoadingMore' : 'setIsLoading';
            commit(loader, true)
            try {
                commit('setAdminSaveParams', params);

                const response = await axios.post('/admin/report/get', { ...params })

                if (response && response.success) {
                    commit('setAdminAnalyticsData', response.data)
                }

            } catch (error) {
                console.warn(error)
            }
            commit(loader, false)

        },

        async getAnalyticsByTable ({ commit, state }, payload) {
            payload.date = state.adminSavedParams.date
            payload.aggregation = _.replace(payload.aggregation, "-", "_")
            commit('setIsLoading', true)

            try {
                const response = await axios.post(`/admin/report/get/${payload.aggregation}`, { ...payload })

                if (response && response.success) {
                    commit('setAggregationTableData', response.data)
                }

            } catch (error) {
                console.warn(error)
            }
            commit("setIsLoading", false)

        },

        async onGetFilterOptions ({ commit, state }, payload) {
            try {
                if (!_.isEmpty(state.filters[payload.permutation])) {
                    return
                }

                commit('setFiltersLoader', true)
                const response = await axios.get('/api/filters/get/options', { params: payload })

                if (response && response.success) {
                    commit('setFilters', { key: payload.permutation, data: response.data });
                }
            } catch (error) {
                console.warn(error)
            }
            commit('setFiltersLoader', false)
        },

        async updateAnalyticsTable({ commit, state }, payload) {
            commit('setIsLoadingMore', true)
            try {
                const { attribute, dimension, type, slug } = payload
                const { dates, permutations, metric_groups } = state.saveFilters;
                const params = {
                    date_from: moment(dates.date_from).format("YYYY-MM"),
                    date_to: moment(dates.date_to).format("YYYY-MM")
                };

                if (!_.isEmpty(permutations)) {
                    params.permutations = { ids: _.map(permutations, 'id') }
                }

                if (!_.isEmpty(metric_groups)) {
                    params.metric_groups = { ids: _.map(metric_groups, 'id') }
                }

                const path = `/analytics/${dimension}/${attribute}/${type}/${slug}`;

                const response = await axios.get(path, { params })

                if (response && response.success) {
                    commit('setAnalyticsData', response.data)
                    commit('setIsLoadingMore', false)
                    return
                }

                if (process.env.MIX_APP_ENV !== 'local.dhap') {
                    // window.location.href = "/error/500";
                }

            } catch (error) {
                console.warn(error)
            }
        }

    },
    mutations: {
        setIsLoading (state, payload) {
            state.isLoading = payload
        },
        setIsLoadingMore (state, payload) {
            state.isLoadingMore = payload
        },
        setAnalyticsData (state, payload) {
            state.analyticsData = payload
        },
        setFiltersLoader (state, payload) {
            state.filterLoader = payload
        },
        setSaveFilters (state, payload) {
            if (payload.reset) {
                state.saveFilters = _.cloneDeep(defaultFilters);
            } else if (!_.isEmpty(payload.key)) {
                state.saveFilters[payload.key] = payload.data
            } else {
                state.saveFilters = payload
            }

            cookies.set(Tokens.Filters, state.saveFilters)
        },
        setFilters (state, payload) {
            if (payload.reset) {
                state.filters = {};
            } else {
                state.filters[payload.key] = payload.data
            }
        },

        // ADMIN

        setAdminAnalyticsData (state, payload) {
            state.adminAnalyticsData = payload
        },
        setAdminSaveParams (state, payload) {
            state.adminSavedParams = _.merge(state.adminSavedParams, payload)
        },

        setAggregationTableData (state, payload) {
            state.aggregationTableData = payload
        }

    },
}
